import { Button, TextField } from "@mui/material";
import './general.css';
import styles from './upload.module.css';
import React, { useState } from "react";

const MaterialFileUpload = ({ types, onUpload, label, uploadLabel, fileName, placeholder }) => {
    const [file, setFile] = useState(null);
    const [error, setError] = useState(null);

    const handleChange = (e) => {
        let selected = e.target.files[0];

        console.log("e.target", e.target.files)

        if (selected && types.includes(selected.type)) {
            setFile(selected);
            setError("");
            return;
        }
        setError("Tipo de archivo invalido");
        setFile(null);
        return;
    };

    const handleUpload = () => {
        if (file) {
            onUpload(file);
            setFile(null);
        }
    };


    return (
        <div className={`${styles.formGroupLabel}`}>
            {placeholder}
            <div className={`${styles.formGroup}`}>

                {!fileName && <label className={`${styles.inputLabel}`}
                    htmlFor="uploadInput"
                    id="demo-simple-select-label">
                    {file ? 'Por favor presione SUBIR para cargar el archivo' : label}
                </label>}
                <div className={`${styles.inputGroup}  ${styles.inputFile}`}>
                    <TextField id="uploadInput" type="file" onChange={handleChange} />
                    <p className={`${styles.fileText}`}>
                        {fileName}
                    </p>
                    {onUpload &&
                        <Button type="button"
                            onClick={handleUpload}
                            variant="contained"
                            className={`${styles.uploadButton}`}>
                            {uploadLabel}
                        </Button>
                    }
                </div>
                <div className="output">
                    {error && <div className={`${styles.error}`}>{error}</div>}
                    {file && <div>{file.name}</div>}
                </div>
            </div>
        </div>
    );
};

export default MaterialFileUpload;
